import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';

Vue.use(VueRouter);

Vue.use(VueGtm, {
  id: 'GTM-NBZMNVG', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  enabled: true,
  debug: process.env.NODE_ENV === 'development',
  loadScript: false,
  trackOnNextTick: false,
});

const routes = [
  {
    path: '/',
    name: 'Quiz',
    component: () => import(/* webpackChunkName: "about" */ '../components/Quiz.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
